import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import chesssLogo from '../images/chessslogo.png';

// MUI Stuff
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

// Redux stuff
import { connect } from 'react-redux';
import { resetPassword } from '../redux/actions/userActions';

const styles = (theme) => ({
  form: theme.form,
  image: theme.image,
  pageTitle: theme.pageTitle,
  textField: theme.textField,
  customError: theme.customError,
  button: theme.button,
  progress: theme.progress,
});

class ResetPassword extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      errors: {},
      success: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.UI.errors) {
      this.setState({ errors: nextProps.UI.errors });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.state.email || !emailRegex.test(this.state.email)) {
      this.setState({
        errors: { email: 'Please enter a valid email address' }
      });
      return;
    }

    const userData = {
      email: this.state.email
    };
    this.props.resetPassword(userData, () => this.setState({ success: true }));
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  render() {
    const {
      classes,
      UI: { loading }
    } = this.props;
    const { errors, success } = this.state;

    return (
      <div className="app-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="login-container">
          <Grid
            container
            className={classes.form}
            style={{
              border: '5px solid gold',
              margin: '0px',
              width: '100%',
              maxWidth: '600px',
              minHeight: '500px',
              padding: '20px',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Grid item style={{
              width: '100%',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '25px'
            }}>
              <img
                src={chesssLogo}
                alt="app-icon"
                className={classes.image}
                style={{
                  maxWidth: '150px',
                  height: 'auto'
                }}
              />
              <div style={{
                color: 'gold',
                fontSize: 'clamp(24px, 5vw, 40px)',
                fontWeight: 'bold'
              }}>
                Reset Password
              </div>
              <div style={{ width: '100%', maxWidth: '400px' }}>
                {!success ? (
                  <form noValidate onSubmit={this.handleSubmit} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '25px'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '15px',
                      width: '100%'
                    }}>
                      <div style={{
                        color: 'white',
                        fontSize: 'clamp(14px, 1.5vw, 16px)',
                        textAlign: 'center',
                        marginBottom: '10px'
                      }}>
                        Enter your email address and we'll send you a link to reset your password.
                      </div>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Email"
                        helperText={errors.email}
                        error={errors.email ? true : false}
                        value={this.state.email}
                        onChange={this.handleChange}
                        style={{
                          width: '90%',
                          padding: '15px',
                          fontSize: 'clamp(16px, 2vw, 20px)',
                          border: errors.email ? '5px solid #ff0000' : '5px solid #3066be',
                          borderRadius: '4px',
                          background: 'white'
                        }}
                      />
                      {errors.email && (
                        <div style={{ color: '#ff0000', fontSize: '14px', textAlign: 'left', width: '90%' }}>
                          {errors.email}
                        </div>
                      )}
                    </div>
                    {errors.general && (
                      <div style={{ color: '#ff0000', fontSize: '14px', marginTop: '10px', textAlign: 'center' }}>
                        {errors.general}
                      </div>
                    )}
                    <button
                      type="submit"
                      style={{
                        width: '70%',
                        padding: '15px',
                        fontSize: 'clamp(16px, 2vw, 20px)',
                        backgroundColor: '#ff0050',
                        border: '3px solid gold',
                        color: 'gold',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                      }}
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress size={20} style={{ color: 'gold' }} />
                      ) : (
                        'SEND RESET LINK'
                      )}
                    </button>
                  </form>
                ) : (
                  <div style={{
                    color: '#4caf50',
                    fontSize: 'clamp(16px, 2vw, 20px)',
                    textAlign: 'center',
                    padding: '20px',
                    backgroundColor: 'rgba(76, 175, 80, 0.1)',
                    borderRadius: '5px',
                    border: '1px solid #4caf50'
                  }}>
                    Reset link sent! Check your email (spam too).
                  </div>
                )}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '15px',
                  alignItems: 'center',
                  marginTop: '25px'
                }}>
                  <div style={{
                    fontSize: 'clamp(16px, 2vw, 24px)',
                    color: 'gold',
                    fontWeight: 'bold'
                  }}>
                    <Link to="/login" style={{ color: 'gold', textDecoration: 'underline', fontWeight: 'normal' }}>Back to Login</Link>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  resetPassword: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI
});

const mapActionsToProps = {
  resetPassword
};

export default connect(
  mapStateToProps,
  mapActionsToProps
  // Capital R on ResetPassword to distinguish from UserActions resetPassword
)(withStyles(styles)(ResetPassword)); 